import { Chip } from "@mui/material"
import { VisibilityOutlined } from "@mui-symbols-material/w300"
import type { ColumnDef } from "@tanstack/react-table"
import dayjs from "dayjs"

import { LinkButton } from "@/components/common/LinkButton"
import { DATE_FORMAT } from "@/constants/formats"
import type { PriceChangeSubmission } from "@/graphql/codegen/graphql"

export const usePriceApprovalColumns = (): ColumnDef<PriceChangeSubmission>[] => {
  return [
    {
      accessorKey: "changeId",
      header: "Change ID",
      cell: ({ row }) => row.original.changeId,
      enableSorting: false,
    },
    {
      accessorKey: "updatedOn",
      header: "Date Changed",
      cell: ({ row }) =>
        row.original.dateChanged ? (
          <Chip
            label={dayjs(row.original.dateChanged).format(DATE_FORMAT.US)}
            size='small'
            className='rounded-sm bg-primary-200'
          />
        ) : null,
      enableSorting: true,
    },
    {
      accessorKey: "reasonForUpdate",
      header: "Reason for Update",
      cell: ({ row }) => row.original.reasonForUpdate ?? null,
      enableSorting: false,
    },
    {
      accessorKey: "productsAffected",
      header: "Products Affected",
      cell: ({ row }) => row.original.productsAffectedCount,
      enableSorting: false,
    },
    {
      accessorKey: "customers",
      header: "Customers",
      cell: ({ row }) => row.original.customersAffectedCount,
      enableSorting: false,
    },
    {
      accessorKey: "submittedBy",
      header: "Submitted By",
      cell: ({ row }) => row.original.submittedBy.name,
      enableSorting: false,
    },
    {
      accessorKey: "assignedToId",
      header: "Assigned To",
      cell: ({ row }) => row.original.assignedTo?.name ?? null,
      enableSorting: false,
    },
    {
      accessorKey: "actions",
      header: "",
      cell: ({ row }) => (
        <LinkButton
          appearance='text'
          size='small'
          startIcon={<VisibilityOutlined />}
          to='/app/pricing/$priceChangeId/review'
          params={{ priceChangeId: row.original.id }}
          data-testid={`dashboard.price-approval.review-button-${row.original.id}`}
        >
          Review Submission
        </LinkButton>
      ),
      size: 50,
      enableSorting: false,
    },
  ]
}
